import loadable from "@loadable/component";
import FullWidthSectionTransform from "./FullWidthSection/transform";
import TwoColumnSectionTransform from "./TwoColumnSection/transform";

export const Blocks = {
	FullWidthSection: loadable(() => import("./FullWidthSection")),
	TwoColumnSection: loadable(() => import("./TwoColumnSection")),
};

export const sectionTransform = {
	FullWidthSection: FullWidthSectionTransform,
	TwoColumnSection: TwoColumnSectionTransform,
};

export default Blocks;
